import { render, staticRenderFns } from "./StakingFI.vue?vue&type=template&id=3453a156&"
import script from "./StakingFI.vue?vue&type=script&lang=js&"
export * from "./StakingFI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports